module.exports = __webpack_public_path__ + "img/hr-tree-04-b-leaves.46f6d0ff.png";